module.exports = __webpack_public_path__ + "static/media/account_circle.8b0f3970.svg";